import Privacy from '@module/privacy';

import { shouldDisplayCookieWall } from '@app/helper/cookie-wall';

export const init = () => {
  if (
    shouldDisplayCookieWall() ||
    (Privacy.userHasClosedBanner() && !Privacy.userAllowsTracking())
  ) {
    // Only init this if the experiment is running or
    // if the user has taken part of that experiment
    Privacy.configure();
  }
};
